import FROM_GALLERY_PAGE_REQUEST from '../actionTypes/FromGalleryActionTypes';

function fromGalleryReducer(state = {}, action) {
    switch (action.type) {
        case FROM_GALLERY_PAGE_REQUEST:
            return { ...action.payload, breadcrumbs: true };
        default:
            return state;
    }
}

export default fromGalleryReducer;
